import React from "react"
import { CLIENT_REPORT_EMPTY_CHART_MESSAGE } from "../../../consts/charts.consts"
import DetailedEstimationLegend from "./DetailedEstimationLegend.compound"
import PieChartCompound from "../../../components/compounds/graphics/PieChart.compound"
import { numberFormatter } from "../../../utils/numbers.utils"
import useHighlightChartData from "../../../hooks/useHighlightChartData.hook"

const SprintDetailedEstimationChart = ({
  data: chartData,
  loading = false,
  chartContainerConfig = {
    shadow: false,
    className: "w-fit p-0 sprint-detailed-estimation-chart mx-auto md:mx-2",
  },
  responsiveContainerConfig = {
    minHeight: "220px",
    minWidth: "220px",
    maxWidth: "220px",
    maxHeight: "220px",
  },
  legend = true,
  legendConfig = {
    verticalAlign: "middle",
    layout: "horizontal",
  },
  width = 220,
  height = 220,
  showEmptyMessage = false,
  emptyMessageConfig = CLIENT_REPORT_EMPTY_CHART_MESSAGE,
  middleLabel,
  middleLabelValue,
  middleLabelConfig = {
    className: "text-5xl font-bold clr-text font-cairo",
  },
  startAngle = -270,
  refChart,
  tooltip = true,
  tooltipTemplate = (data) => (
    <ColorLabelPercentageTooltipTemplate
      value={data?.value}
      total={data?.extraInfo?.total}
      color={data?.color}
      label={data?.name || data?.extraInfo?.label || data?.estimationType}
    />
  ),
}) => {
  const { data, handleMouseEnterLegend, handleMouseLeaveLegend } =
    useHighlightChartData({
      initialData: chartData,
    })

  const customLegendTemplate = (legendData) => {
    return (
      <DetailedEstimationLegend
        className="sprint-detailed-estimation-chart-legend flex-1"
        data={legendData}
        onMouseEnter={handleMouseEnterLegend}
        onMouseLeave={handleMouseLeaveLegend}
        loading={loading}
      />
    )
  }

  const getFilteredData = () => {
    const filteredElements =
      data?.[0]?.data?.filter(
        (item) => item?.estimationType !== "TOTAL_POINTS"
      ) || []
    if (!filteredElements?.length) {
      return []
    }
    return [
      {
        data: filteredElements,
      },
    ]
  }
  return (
    <div
      className={`doughnut-chart flex gap-2 flex-column md:flex-row`}
      ref={refChart}
    >
      <PieChartCompound
        data={getFilteredData()}
        chartContainerConfig={chartContainerConfig}
        label={false}
        responsiveContainerConfig={responsiveContainerConfig}
        legendConfig={legendConfig}
        refChart={refChart}
        width={width}
        height={height}
        showEmptyMessage={showEmptyMessage}
        emptyMessageConfig={emptyMessageConfig}
        middleLabel={middleLabel}
        middleLabelConfig={{
          value: middleLabelValue,
          ...middleLabelConfig,
        }}
        startAngle={startAngle}
        loading={loading}
        tooltip={tooltip}
        tooltipTemplate={tooltipTemplate}
      />
      {legend && customLegendTemplate(chartData[0]?.data)}
    </div>
  )
}

const ColorLabelPercentageTooltipTemplate = ({
  value,
  total,
  color,
  label,
}) => {
  const percentage = (value / total) * 100
  return (
    <div className="custom-recharts-tooltip flex gap-3 text-white">
      <div className="flex gap-1">
        <div
          className="flex align-items-center justify-content-center tendency-chip"
          style={{
            background: color,
            padding: "3.5px",
            aspectRatio: "1 / 1",
            borderRadius: "6px",
          }}
        ></div>
        <span>{label}</span>
      </div>
      <span>{numberFormatter(percentage)}%</span>
    </div>
  )
}
export default SprintDetailedEstimationChart
